import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import "./index.css";

import { App } from "./App";
import { IS_DEV } from "./config";

if (!IS_DEV) {
  Sentry.init({
    dsn: "https://dd1b26023126d302ad4ddb1b140c8d3a@o4505788935897088.ingest.us.sentry.io/4508699677818880",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root") as HTMLElement)?.render(
  <StrictMode>
    <App />
  </StrictMode>
);
